import * as actionType from './type'

const INITIAL_STATE = {
    customer: [],
    isLoading: false,
    error: "",
    pagedCustomers : null
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_GET_PAGED_CUSTOMERS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_PAGED_CUSTOMERS: {
            return {
                ...state,
                pagedCustomers: action.payload
            }
        }
        case actionType.REQUEST_GET_ALL_CUSTOMERS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: "Please try again"
            }
        }

        case actionType.RECEIVED_GET_ALL_CUSTOMERS: {
            return {
                ...state,
                isLoading: false,
                customer: action.payload
            }
        }

        default: 
            return state;
    }
}